module.exports = __webpack_public_path__ + "static/media/4980.bba8410a.jpg";